import { HeaderPage } from 'components/HeaderPage';
import Head from 'next/head';
import React from 'react';

function Home() {
  return (
    <>
      <Head>
        <title>Page Edit</title>
      </Head>
      <HeaderPage title="Welcome" />
    </>
  );
}

export default Home;
